import { memo, useMemo } from 'react';

import { Box } from '@material-ui/core';

import { colors } from '../../assets';
import { ImportantBadgeProps } from './ImportantBadge.types';

export const ImportantBadge = memo(({ children, type = 'info', ...rest }: ImportantBadgeProps) => {
  const bgColor = useMemo(() => {
    switch (type) {
      case 'info':
        return colors.complementary.blue.shade04;

      case 'error':
        return colors.functionals.alertLight;

      default:
        return colors.complementary.blue.shade04;
    }
  }, [type]);

  const borderColor = useMemo(() => {
    switch (type) {
      case 'info':
        return colors.complementary.blue.shade02;

      case 'error':
        return colors.functionals.alert;

      default:
        return colors.complementary.blue.shade02;
    }
  }, [type]);

  return (
    <Box p={1} bgcolor={bgColor} border={`1px solid ${borderColor}`} borderRadius={4} {...rest}>
      {children}
    </Box>
  );
});
